// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useState } from "react"


interface LandingPageHeadingProps {
  title: string
  logo: string
}


const LandingPageHeading: React.FC<LandingPageHeadingProps> = ({
  logo,
  title
}) => {
  const [loaded, setLoaded] = useState<boolean>(false)
  return (
    <div className="heading" style={{visibility: (!loaded) ? "hidden" : "visible"}}>
      <img
        alt="Molano"
        onLoad={() => setLoaded(true)}
        src={logo}
      />
      <h1>{title}</h1>
    </div>
  )
}


export { LandingPageHeading }